import { Button } from '@fluentui/react-components';
import { Globe20Regular } from '@fluentui/react-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface Pillar2ReportButtonProps {
    onClick: () => void;
    disabled: boolean;
    isPanelOpen: boolean;
}

const Pillar2ReportButton: React.FC<Pillar2ReportButtonProps> = ({ onClick, disabled, isPanelOpen }) => {
    const { t } = useTranslation();
    const label = t('pillar2ReturnFiling').toString();

    return (
        <Button
            appearance='secondary'
            onClick={onClick}
            disabled={disabled}
            icon={<Globe20Regular />}
            aria-label={label}
            aria-pressed={isPanelOpen}
        >
            {label}
        </Button>
    );
};

export default Pillar2ReportButton;
